import(/* webpackMode: "eager", webpackExports: ["Slot"] */ "/app/node_modules/@radix-ui/react-slot/dist/index.mjs");
;
import(/* webpackMode: "eager" */ "/app/node_modules/next/dist/client/link.js");
